import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "./assets/css/index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from 'react-auth-kit';


ReactDOM.render(
	<React.StrictMode>
	  <AuthProvider
		authType={'cookie'}
		authName={'_auth'}
		cookieDomain={window.location.hostname}
		cookieSecure={window.location.protocol === 'https'}
	  >
		<App />
	  </AuthProvider>
	</React.StrictMode>,
	document.getElementById('root')
  );